import { useQuery } from '@tanstack/react-query'
import {
  reportService, type ReportParams,
  type BookingReportRow, type RevenueReportRow, type TrainerReportRow, type StudentReportRow, type SchoolReportRow,
} from '@/api/services/reportService'

interface ReportOpts { enabled?: boolean; scope?: 'admin' | 'school' }

export function useBookingReport(p?: ReportParams, opts: ReportOpts = {}) {
  const { enabled = true, scope = 'admin' } = opts
  return useQuery({
    queryKey: ['reports', 'bookings', scope, p],
    queryFn: () => scope === 'school'
      ? reportService.schoolReportPreview<BookingReportRow>('booking', p)
      : reportService.bookingsPreview(p),
    staleTime: 60_000,
    enabled,
  })
}
export function useRevenueReport(p?: ReportParams, opts: ReportOpts = {}) {
  const { enabled = true, scope = 'admin' } = opts
  return useQuery({
    queryKey: ['reports', 'revenue', scope, p],
    queryFn: () => scope === 'school'
      ? reportService.schoolReportPreview<RevenueReportRow>('revenue', p)
      : reportService.revenuePreview(p),
    staleTime: 60_000,
    enabled,
  })
}
export function useTrainerReport(p?: ReportParams, opts: ReportOpts = {}) {
  const { enabled = true, scope = 'admin' } = opts
  return useQuery({
    queryKey: ['reports', 'trainer', scope, p],
    queryFn: () => scope === 'school'
      ? reportService.schoolReportPreview<TrainerReportRow>('trainer', p)
      : reportService.trainerPreview(p),
    staleTime: 60_000,
    enabled,
  })
}
export function useStudentReport(p?: ReportParams, opts: ReportOpts = {}) {
  const { enabled = true, scope = 'admin' } = opts
  return useQuery({
    queryKey: ['reports', 'student', scope, p],
    queryFn: () => scope === 'school'
      ? reportService.schoolReportPreview<StudentReportRow>('student', p)
      : reportService.studentPreview(p),
    staleTime: 60_000,
    enabled,
  })
}
export function useSchoolReport(p?: ReportParams, opts: ReportOpts = {}) {
  const { enabled = true, scope = 'admin' } = opts
  return useQuery({
    queryKey: ['reports', 'school', scope, p],
    queryFn: () => scope === 'school'
      ? reportService.schoolReportPreview<SchoolReportRow>('school', p)
      : reportService.schoolPreview(p),
    staleTime: 60_000,
    enabled,
  })
}
